import React from 'react'
import { useTranslation } from 'react-i18next'
import styled from 'styled-components'

export const CurrencyCardEmptyChart: React.FC = () => {
  const { t } = useTranslation()

  return (
    <Root>
      <EmptyChartMessage>{t('common.no_data')}</EmptyChartMessage>
      <EmptyChartFooter>
        {Array.from({ length: 40 }).map((_, i) => (
          <span key={i} />
        ))}
      </EmptyChartFooter>
    </Root>
  )
}

const Root = styled.div`
  color: var(--text-8);

  font-size: 11px;
  font-weight: 500;
  line-height: 16px;

  display: grid;
  grid-template-rows: 1fr auto;
  height: 100%;
  align-content: center;
`

const EmptyChartMessage = styled.span`
  display: grid;
  align-content: center;
  justify-content: center;
`

const EmptyChartFooter = styled.div`
  display: grid;
  grid-auto-flow: column;
  gap: 1px;

  > span {
    background: #484848;
    height: 3px;
    width: 2px;
    border-radius: 50%;
  }
`
